import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageModule } from 'primeng/image';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageModule } from 'primeng/message';

import { EarhivUiComponents } from './models/earhiv-ui-components';

import {
  NTAPPrimengModule,
  PrimeNGButtonHeadingActionComponent
} from '@ntap/primeng';
import { ImagePanelComponent } from './components/image-panel/image-panel.component';
import { SaveCloseChildItemComponent } from './components/actions/save-close-child-item/save-close-child-item.component';
import { LinkPipe } from './pipes/link.pipe';
import { RemoveImageComponent } from './components/actions/remove-image/remove-image.component';

@NgModule({
  declarations: [
    ImagePanelComponent,
    SaveCloseChildItemComponent,
    LinkPipe,
    RemoveImageComponent
  ],
  imports: [
    CommonModule,
    ImageModule,
    FileUploadModule, // TODO ne bi trebalo biti ovdje, nego samo u admin verziji komponente ?
    MessageModule,
    NTAPPrimengModule.forRoot()
  ],
  exports: [
    NTAPPrimengModule,
    ImagePanelComponent,
    LinkPipe,
    RemoveImageComponent
  ]
})
export class SharedModule {
  private static CUSTOM_REGISTRY = new Map<string, Type<any>>([
    [
      EarhivUiComponents.DEFAULT_HEADING_ACTION, // FIXME maknuti nakon sto u NTAP-u popravimo ntapActionServer da salje $selected
      PrimeNGButtonHeadingActionComponent
    ],
    [
      EarhivUiComponents.SAVE_CLOSE_CHILD_ITEM_ACTION,
      SaveCloseChildItemComponent
    ]
  ]);

  public static getComponentRegistry() {
    return SharedModule.CUSTOM_REGISTRY;
  }
}
